import React, {useEffect } from 'react'
import BreadCrumb from 'ui-components/lib/components/BreadCrumb'
import { Flex } from 'reflexbox'
import { useHistory } from 'react-router-dom'
import './style.css'
import paperAirplane from '../../assets/icons/paperAirplane.svg'
import mailbox from '../../assets/icons/mailbox.svg'
import chevron from '../../assets/icons/chevron.svg'

const preventDevToolsUnblur = () => {
  const elements = document.querySelectorAll('.blurred-container, .blurred-container *');
  elements.forEach(element => {
    element.style.setProperty('filter', 'blur(5px)', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');
    element.style.setProperty('user-select', 'none', 'important');
  });
};

const ContractManagement = (props) => {
  console.log('props', props)
  const history = useHistory()
  const navigationLinks = [{ label: 'Início', onClick: () => history.push('/dashboard') }, { label: 'Gestão Contratual' }]

  
  useEffect(() => {
    if (props.isAuthorized === false) {
      const style = document.createElement('style')
      style.innerHTML = `
      .blurred-container {
        filter: blur(5px) !important;
        pointer-events: none !important;
        user-select: none !important;
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        position: relative;
        z-index: 1;
      }
      .blurred-container * {
        pointer-events: none !important;
        filter: blur(5px) !important;
      }
      .blurred-container::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.5);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        z-index: -1;
      }
    `
      document.head.appendChild(style)
      preventDevToolsUnblur();
      return () => document.head.removeChild(style)
    }
  }, [props.isAuthorized])

  return (
    <Flex width={1} justifyContent="center" flexDirection="column" className={`${props.isAuthorized === false ? 'blurred-container' : ''}`}>
      <Flex width={1} mb={3} className="breadCrumb">
        <BreadCrumb ml={-3} navigationLinks={navigationLinks} />
      </Flex>
      <Flex width={1} flexDirection="column">
        <div className='my-services'>
          <h4>Gestão Contratual</h4>
          <div className='items'>
            <div className='item'>
              <img src={mailbox} alt='' />
              <h5>Documentos</h5>
              <div className='text'>
                Anexe contratos e você poderá ter a gestão do prazo de vencimento, edite quando achar necessário e seja notificado por e-mail.
              </div>
              <button type='button' onClick={() => history.push('/dashboard/gestao-contratual/documents')}> Ver documentos <img src={chevron}  alt='' /></button>
            </div>
            <div className='item'>
              <img src={paperAirplane}  alt='' />
              <h5>Alertas</h5>
              <div className='text'>
                Apresentação de todos os resultados dos serviços que você solicitou recentemente.
              </div>
              <button type='button' onClick={() => history.push('/dashboard/gestao-contratual/alerts')}> Criar alertas <img src={chevron}  alt='' /></button>
            </div>
          </div>
        </div>
      </Flex>
    </Flex>
  )
}

export default ContractManagement
